{
	"logout": "Sair",
	"org": "Empresa",
	"place": "Local",
	"event": "Evento",
	"language": "Linguagem"
}
